(() => {
  const body = document.body;
  const header = document.querySelector('[data-header]');
  const drawer = document.querySelector('[data-drawer]');
  const allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.documentElement.classList.remove('no-js');
  body.classList.add('is-loaded');

  if (header) {
    const setHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    setHeader();
    window.addEventListener('scroll', setHeader, { passive: true });
  }

  document.querySelectorAll('[data-back-to-top]').forEach((control) => {
    const button = control.querySelector('button');
    const threshold = Number(control.dataset.threshold) || 700;
    if (!button) return;

    const setBackToTop = () => {
      const isVisible = window.scrollY >= threshold;
      control.classList.toggle('is-visible', isVisible);
      control.setAttribute('aria-hidden', String(!isVisible));
      button.tabIndex = isVisible ? 0 : -1;
    };

    setBackToTop();
    window.addEventListener('scroll', setBackToTop, { passive: true });
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: allowMotion ? 'smooth' : 'auto' });
    });
  });

  if (drawer) {
    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('drawer-open');
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('drawer-open');
    };

    document.querySelectorAll('[data-drawer-open]').forEach((button) => button.addEventListener('click', openDrawer));
    document.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  }

  const closeDesktopMenus = (except = null) => {
    document.querySelectorAll('[data-nav-item].is-open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  };

  document.querySelectorAll('[data-nav-toggle]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const item = button.closest('[data-nav-item]');
      if (!item) return;
      const willOpen = !item.classList.contains('is-open');
      closeDesktopMenus(item);
      item.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', String(willOpen));
    });
  });

  document.addEventListener('click', () => closeDesktopMenus());

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const submenu = document.getElementById(button.getAttribute('aria-controls'));
      if (!submenu) return;
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(willOpen));
      submenu.hidden = !willOpen;
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    const loadRecommendations = () => {
      if (!section.dataset.url || section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';

      fetch(section.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;
          const recommendations = container.querySelector('[data-product-recommendations]');
          if (recommendations?.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
        })
        .catch(() => {
          section.dataset.loaded = 'false';
        });
    };

    if ('IntersectionObserver' in window) {
      const recommendationObserver = new IntersectionObserver((entries, observer) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      recommendationObserver.observe(section);
    } else {
      loadRecommendations();
    }
  });

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.16 });

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    const step = () => Math.max(280, Math.round(track.clientWidth * 0.72));
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-accordion]').forEach((accordion) => {
    accordion.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const images = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
    const stage = gallery.querySelector('[data-gallery-stage]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    const mobileGallery = window.matchMedia('(max-width: 640px)');
    let activeIndex = 0;
    let scrollFrame;

    if (!images.length) return;

    const activate = (requestedIndex, scrollToMedia = false) => {
      activeIndex = Math.max(0, Math.min(images.length - 1, requestedIndex));

      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
      images.forEach((image, index) => image.classList.toggle('is-active', index === activeIndex));
      if (current) current.textContent = String(activeIndex + 1);

      if (scrollToMedia && mobileGallery.matches && stage) {
        stage.scrollTo({ left: images[activeIndex].offsetLeft, behavior: allowMotion ? 'smooth' : 'auto' });
      }

      thumbs[activeIndex]?.scrollIntoView({ behavior: allowMotion ? 'smooth' : 'auto', block: 'nearest', inline: 'nearest' });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        activate(index, true);
      });
    });

    previous?.addEventListener('click', () => activate(activeIndex - 1, true));
    next?.addEventListener('click', () => activate(activeIndex + 1, true));

    stage?.addEventListener('keydown', (event) => {
      if (!mobileGallery.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      activate(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
    });

    stage?.addEventListener('scroll', () => {
      if (!mobileGallery.matches) return;
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const closestIndex = images.reduce((closest, image, index) => (
          Math.abs(image.offsetLeft - stage.scrollLeft) < Math.abs(images[closest].offsetLeft - stage.scrollLeft) ? index : closest
        ), 0);
        if (closestIndex !== activeIndex) activate(closestIndex);
      });
    }, { passive: true });

    mobileGallery.addEventListener?.('change', (event) => {
      if (!event.matches && stage) stage.scrollLeft = 0;
      activate(activeIndex, event.matches);
    });
  });

  const parallaxSections = document.querySelectorAll('[data-parallax-section]');
  if (allowMotion && parallaxSections.length) {
    const parallax = () => {
      parallaxSections.forEach((section) => {
        const media = section.querySelector('[data-parallax-media]');
        if (!media) return;
        const rect = section.getBoundingClientRect();
        const progress = Math.min(1, Math.max(-1, rect.top / window.innerHeight));
        media.style.transform = `translateY(${progress * -18}px)`;
      });
    };
    parallax();
    window.addEventListener('scroll', parallax, { passive: true });
  }

  document.querySelectorAll('[data-before-after]').forEach((section) => {
    const after = section.querySelector('[data-ba-after]');
    const handle = section.querySelector('[data-ba-handle]');
    const range = section.querySelector('[data-ba-range]');
    if (!after || !handle || !range) return;

    const setCompare = () => {
      const value = Number(range.value);
      after.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
      handle.style.left = `${value}%`;
    };

    setCompare();
    range.addEventListener('input', setCompare);
  });

  const fragranceNotes = {
    fresh: {
      eyebrow: 'First impression',
      title: 'Fresh salon air',
      copy: 'A clean, just-finished feeling that keeps the ritual light, polished, and easy to wear.'
    },
    botanical: {
      eyebrow: 'Heart note',
      title: 'Soft botanical clarity',
      copy: 'Green, airy cues that echo the natural materials and refined formula story.'
    },
    mineral: {
      eyebrow: 'Texture note',
      title: 'Ivory stone calm',
      copy: 'A smooth, minimal impression inspired by polished stone, water-light serum, and quiet luxury.'
    },
    clean: {
      eyebrow: 'Final trail',
      title: 'Silky clean finish',
      copy: 'A subtle fresh finish designed to feel professional, modern, and never overpowering.'
    }
  };

  document.querySelectorAll('[data-fragrance]').forEach((section) => {
    const panel = section.querySelector('[data-note-panel]');
    if (!panel) return;

    section.querySelectorAll('[data-note]').forEach((button) => {
      button.addEventListener('click', () => {
        const note = fragranceNotes[button.dataset.note];
        if (!note) return;
        section.querySelectorAll('[data-note]').forEach((item) => item.classList.toggle('is-active', item === button));
        panel.style.opacity = '0';
        setTimeout(() => {
          panel.querySelector('span').textContent = note.eyebrow;
          panel.querySelector('h3').textContent = note.title;
          panel.querySelector('p').textContent = note.copy;
          panel.style.opacity = '1';
        }, 120);
      });
    });
  });

  document.querySelectorAll('[data-hair-quiz]').forEach((quiz) => {
    const steps = quiz.querySelectorAll('[data-quiz-step]');
    const result = quiz.querySelector('[data-quiz-result]');
    const title = quiz.querySelector('[data-quiz-title]');
    const copy = quiz.querySelector('[data-quiz-copy]');
    const answers = [];

    const results = {
      frizz: ['Silky control ritual', 'Warm a small amount, glide through the outer layer, then press over flyaways for a smooth, polished surface.'],
      dryness: ['Soft-end ritual', 'Focus the serum through mid-lengths and ends to soften dry-looking areas while keeping movement airy.'],
      shine: ['Brilliant shine ritual', 'Finish styled hair with a light surface pass to catch light and create a clean reflective glow.'],
      heat: ['Blowout polish ritual', 'Use as the final step after heat styling to refine the surface and add silky reflection.'],
      air: ['Air-dry smooth ritual', 'Apply sparingly to damp lengths, then touch up dry ends once hair settles.'],
      night: ['Evening reset ritual', 'Smooth a small amount into ends before bed and wake up to softer-looking lengths.']
    };

    const showStep = (index) => {
      steps.forEach((step) => step.classList.toggle('is-active', step.dataset.quizStep === String(index)));
    };

    quiz.querySelectorAll('[data-quiz-answer]').forEach((button) => {
      button.addEventListener('click', () => {
        button.closest('.quiz-step')?.querySelectorAll('[data-quiz-answer]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        answers.push(button.dataset.quizAnswer);

        if (answers.length < steps.length) {
          showStep(answers.length);
          return;
        }

        const selected = results[answers[0]] || results[answers[1]] || results.shine;
        title.textContent = selected[0];
        copy.textContent = selected[1];
        result.classList.add('is-visible');
      });
    });

    quiz.querySelector('[data-quiz-reset]')?.addEventListener('click', () => {
      answers.length = 0;
      quiz.querySelectorAll('[data-quiz-answer]').forEach((button) => button.classList.remove('is-active'));
      result.classList.remove('is-visible');
      showStep(0);
    });
  });
})();
